import { InteractivityActionTypeValue } from '../InteractivityActionTypeValue';

export const waitUntilInteractivityActionSnapshotMetadata = {
  typeId: InteractivityActionTypeValue.WaitUntil,
};
